// Synthetic electropherogram-style analytical signals for the signal viewer.
function mulberry32(a) {
  return function () {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

function trace(seed, peaks, { noise = 0.02, artifact = null } = {}) {
  const rng = mulberry32(seed);
  const g = () => {
    let u = 0,
      v = 0;
    while (u === 0) u = rng();
    while (v === 0) v = rng();
    return Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v);
  };
  const pts = [];
  for (let i = 0; i <= 240; i++) {
    const t = i / 20; // 0..12 min
    let s = 0.02 + 0.004 * Math.sin(t * 0.8);
    peaks.forEach((p) => {
      s += p.h * Math.exp(-((t - p.t) ** 2) / (2 * (p.w ?? 0.09) ** 2));
    });
    if (artifact) s += artifact.h * Math.exp(-((t - artifact.t) ** 2) / (2 * artifact.w ** 2));
    s += g() * noise;
    pts.push({ t: Number(t.toFixed(2)), signal: Math.max(0, Number(s.toFixed(4))) });
  }
  return pts;
}

export const SIGNAL_RUNS = [
  {
    id: "A",
    name: "Run A",
    desc: "Passing reference profile",
    verdict: "Pass",
    verdictTone: "success",
    referenceMarker: 5.5,
    threshold: 0.12,
    noiseBaseline: 0.02,
    peaks: [
      { t: 5.5, h: 0.5, label: "Reference Marker" },
      { t: 7.41, h: 0.35, label: "Minor Peak" },
      { t: 8.02, h: 1.0, label: "Main Peak" },
    ],
    artifact: null,
    points: trace(101, [
      { t: 5.5, h: 0.5 },
      { t: 7.41, h: 0.35 },
      { t: 8.02, h: 1.0 },
    ]),
  },
  {
    id: "B",
    name: "Run B",
    desc: "Main peak near synthetic migration limit",
    verdict: "Pass — Borderline Migration",
    verdictTone: "warn",
    referenceMarker: 5.5,
    threshold: 0.12,
    noiseBaseline: 0.022,
    peaks: [
      { t: 5.5, h: 0.5, label: "Reference Marker" },
      { t: 7.44, h: 0.33, label: "Minor Peak" },
      { t: 8.16, h: 0.92, label: "Main Peak (shifted)" },
    ],
    artifact: null,
    points: trace(202, [
      { t: 5.5, h: 0.5 },
      { t: 7.44, h: 0.33 },
      { t: 8.16, h: 0.92 },
    ], { noise: 0.022 }),
  },
  {
    id: "C",
    name: "Run C",
    desc: "Elevated noise with a broad late-eluting feature",
    verdict: "Candidate Signal Artifact",
    verdictTone: "critical",
    referenceMarker: 5.5,
    threshold: 0.12,
    noiseBaseline: 0.05,
    peaks: [
      { t: 5.5, h: 0.5, label: "Reference Marker" },
      { t: 8.02, h: 0.95, label: "Main Peak" },
    ],
    artifact: { t: 9.3, h: 0.28, w: 0.22, label: "Candidate Artifact (microbubble-type)" },
    points: trace(303, [
      { t: 5.5, h: 0.5 },
      { t: 8.02, h: 0.95 },
    ], { noise: 0.05, artifact: { t: 9.3, h: 0.28, w: 0.22 } }),
  },
  {
    id: "D",
    name: "Run D",
    desc: "Reference marker detected earlier than expected",
    verdict: "Reference Marker Shift",
    verdictTone: "warn",
    referenceMarker: 5.5,
    threshold: 0.12,
    noiseBaseline: 0.02,
    peaks: [
      { t: 5.18, h: 0.5, label: "Observed Marker (5.18 min)" },
      { t: 7.38, h: 0.34, label: "Minor Peak" },
      { t: 8.0, h: 0.98, label: "Main Peak" },
    ],
    artifact: null,
    points: trace(404, [
      { t: 5.18, h: 0.5 },
      { t: 7.38, h: 0.34 },
      { t: 8.0, h: 0.98 },
    ]),
  },
];
